export const DAY_IN_MILLISECONDS = 1000 * 3600 * 24;
export const DAYS_IN_WEEK = 7;
